import {useAddNotification} from '@logistics-frontend/blocks'
import {FrameMessageError} from '@logistics-frontend/hooks'
import {get, noop} from '@logistics-frontend/utils'
import React, {useCallback} from 'react'

import {useFetchCards, useFetchCardTrustBindingUrlTransition} from '../../shared/hooks'
import {CardAddModal as CardAddModalBase} from '../../shared/ui'
import {CardAddModalProps} from './CardAddModal.types'

const CardAddModal: React.FC<CardAddModalProps> = ({scope, onSuccess = noop, onClose}) => {
  const addNotification = useAddNotification()
  const {isCardTrustBindingUrlPending, cardTrustBindingUrl = ''} = useFetchCardTrustBindingUrlTransition(scope)
  const {fetchCardsHandler} = useFetchCards(scope)

  const abortHandler = useCallback<VoidFunction>(() => {
    onClose()
  }, [onClose])

  const errorHandler = useCallback(
    (errorMessage: FrameMessageError) => {
      onClose()
      addNotification(get('reason', errorMessage), {
        type: 'error',
      })
    },
    [onClose, addNotification],
  )

  const successHandler = useCallback<VoidFunction>(() => {
    fetchCardsHandler()
    onClose()
    onSuccess()
  }, [fetchCardsHandler, onClose, onSuccess])

  return (
    <CardAddModalBase
      isLoading={isCardTrustBindingUrlPending}
      onAbort={abortHandler}
      onClose={onClose}
      onError={errorHandler}
      onSuccess={successHandler}
      trustUrl={cardTrustBindingUrl}
    />
  )
}

CardAddModal.displayName = 'CardAddModalWidget'

export default React.memo(CardAddModal)
